import React from "react";

interface InstructionTipProp {
  imgKey: string;
  imgAction: string;
  imgHeight?: number;
  lblAction: string;
  txtAction?: string;
  className?: string;
}

const InstructionTip: React.FC<InstructionTipProp> = ({
  imgKey,
  imgAction,
  imgHeight = 12,
  lblAction,
  txtAction,
  className,
}) => {
  return (
    <div className={`${className} flex flex-col items-center`}>
      <img className={`h-${imgHeight}`} src={imgKey} alt="" />

      <div className="mt-2 flex items-center">
        <img className="mr-2 w-3 text-3xs" src={imgAction} alt="" />
        <p className="text-white">{lblAction}</p>
      </div>
      {txtAction && txtAction !== "" && (
        <p className="text-xs text-center text-white">{txtAction}</p>
      )}
    </div>
  );
};

export default InstructionTip;
